import { useContext, useMemo } from 'react';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

const listingGroupActivityName = 'ListingGroupPage';

const schema = {
  scenario: [
    {
      name: 'ListingGroup',
      value: 'ListingGroup',
      activity: [
        { name: listingGroupActivityName, value: listingGroupActivityName },
      ],
    },
  ],
};

function getActivity(instrumentation) {
  instrumentation.addScenario(schema);

  const scenario = instrumentation.ListingGroup.create();
  const activity = scenario[listingGroupActivityName].create();

  return activity;
}

function getLogger(activity) {
  function signal(message: string) {
    activity.signal(message);
  }
  return { signal };
}

export function useLogger() {
  const instrumentation = useContext(InstrumentationContext);
  const activity = useMemo(() => getActivity(instrumentation), [instrumentation]);
  const logger = useMemo(() => getLogger(activity), [activity]);
  return logger;
}
